export default {
  'pages.openapi.overview.title': '開放平台概覽',
  'pages.openapi.overview.loadFailed': '載入用量概覽失敗（介面可能尚未就緒）',
  'pages.openapi.overview.docsTitle': '接入文檔',
  'pages.openapi.overview.docsDesc':
    '開放平台 BasePath 為 /v1，回應信封為 {code,message,data,request_id}；使用 API Key 時在 Authorization 頭攜帶 Bearer sk_live_... / sk_test_...。密鑰明文僅在建立或輪換時展示一次，請妥善保存。',
  'pages.openapi.overview.level': '目前等級',
  'pages.openapi.overview.qps': 'QPS 上限',
  'pages.openapi.overview.apps': '應用數',
  'pages.openapi.overview.appsSuffix': '（上限 {maxApps}，每應用 Key {maxKeys}）',
  'pages.openapi.overview.dailyUsage': '今日用量',
  'pages.openapi.status.active': '啟用',
  'pages.openapi.status.disabled': '停用',
  'pages.openapi.apps.title': '應用與密鑰',
  'pages.openapi.apps.listTitle': '我的應用',
  'pages.openapi.apps.create': '建立應用',
  'pages.openapi.apps.createModal': '建立應用',
  'pages.openapi.apps.name': '應用名稱',
  'pages.openapi.apps.nameRequired': '請輸入名稱',
  'pages.openapi.apps.description': '描述',
  'pages.openapi.apps.status': '狀態',
  'pages.openapi.apps.createdAt': '建立時間',
  'pages.openapi.apps.createSuccess': '應用已建立',
  'pages.openapi.apps.createFailed': '建立失敗',
  'pages.openapi.apps.loadFailed': '載入應用失敗',
  'pages.openapi.apps.keysLoadFailed': '載入密鑰失敗',
  'pages.openapi.apps.delete': '刪除',
  'pages.openapi.apps.deleteConfirm': '確定刪除該應用？',
  'pages.openapi.apps.deleted': '已刪除',
  'pages.openapi.apps.createKey': '建立 Key',
  'pages.openapi.apps.createKeyModal': '建立 API Key',
  'pages.openapi.apps.keyCreateSuccess': '密鑰已建立',
  'pages.openapi.apps.keyCreateFailed': '建立密鑰失敗',
  'pages.openapi.apps.noPlainKey': '未返回明文密鑰',
  'pages.openapi.apps.plainKeyTitle': '請妥善保存 API Key',
  'pages.openapi.apps.plainKeyHint': '明文僅展示一次，關閉後無法再次查看。',
  'pages.openapi.apps.copy': '複製',
  'pages.openapi.apps.copied': '已複製',
  'pages.openapi.apps.copyFailed': '複製失敗，請手動選擇',
  'pages.openapi.apps.close': '關閉',
  'pages.openapi.apps.key.name': '名稱',
  'pages.openapi.apps.key.namePlaceholder': '生產主 Key',
  'pages.openapi.apps.key.prefix': '前綴',
  'pages.openapi.apps.key.env': '環境',
  'pages.openapi.apps.key.status': '狀態',
  'pages.openapi.apps.key.createdAt': '建立時間',
  'pages.openapi.apps.key.disable': '停用',
  'pages.openapi.apps.key.disableConfirm': '確定停用該密鑰？',
  'pages.openapi.apps.key.disabled': '已停用',
  'pages.openapi.apps.key.enable': '啟用',
  'pages.openapi.apps.key.enableConfirm': '確定啟用該密鑰？',
  'pages.openapi.apps.key.enabled': '已啟用',
  'pages.openapi.apps.key.rotate': '輪換',
  'pages.openapi.apps.key.rotateConfirm': '輪換將產生新密鑰並返回明文一次，確定？',
  'pages.openapi.apps.key.rotated': '已輪換',
  'pages.openapi.apps.key.delete': '刪除',
  'pages.openapi.apps.key.deleteConfirm': '確定刪除該密鑰？不可恢復',
  'pages.openapi.apps.key.deleted': '已刪除',
  'pages.openapi.logs.title': '呼叫記錄',
  'pages.openapi.logs.listTitle': '呼叫明細',
  'pages.openapi.logs.dailyTitle': '近 14 日用量',
  'pages.openapi.logs.dailyEmpty': '暫無日用量資料',
  'pages.openapi.logs.date': '日期',
  'pages.openapi.logs.count': '呼叫次數',
  'pages.openapi.logs.createdAt': '時間',
  'pages.openapi.logs.requestId': 'Request ID',
  'pages.openapi.logs.requestIdPlaceholder': '貼上介面回傳的 request_id',
  'pages.openapi.logs.detail': '詳情',
  'pages.openapi.logs.detailTitle': '呼叫詳情',
  'pages.openapi.logs.detailLoading': '載入中…',
  'pages.openapi.logs.requestQuery': 'Query',
  'pages.openapi.logs.requestBody': '入參',
  'pages.openapi.logs.responseBody': '回應',
  'pages.openapi.logs.app': '應用',
  'pages.openapi.logs.appId': '應用 ID',
  'pages.openapi.logs.apiKey': 'API Key',
  'pages.openapi.logs.userId': '用戶 ID',
  'pages.openapi.logs.apiKeyId': 'Key ID',
  'pages.openapi.logs.keyPrefix': 'Key 前綴',
  'pages.openapi.logs.method': '方法',
  'pages.openapi.logs.path': '路徑',
  'pages.openapi.logs.statusCode': 'HTTP',
  'pages.openapi.logs.code': '業務碼',
  'pages.openapi.logs.latency': '耗時(ms)',
  'pages.openapi.logs.loadFailed': '載入失敗',
  'pages.openapi.planTiers.title': '開放平台套餐配置',
  'pages.openapi.planTiers.level': '等級',
  'pages.openapi.planTiers.levelTip': '套餐檔位等級（1–5），與用戶資料中的 Level 對齊，數字越大檔位越高。',
  'pages.openapi.planTiers.name': '名稱',
  'pages.openapi.planTiers.qps': 'QPS',
  'pages.openapi.planTiers.qpsTip':
    '每秒請求數上限（Queries Per Second）。作為該檔位 API Key 呼叫的預設限流：穩態速率為該值，突發容量約為 QPS×2（至少 5）。僅約束 API Key 呼叫；控制台/管理端不計。單一 Key 可另行覆蓋。超限回傳 HTTP 429（業務碼 42901）。',
  'pages.openapi.planTiers.dailyQuota': '日配額',
  'pages.openapi.planTiers.dailyQuotaTip':
    '每個自然日允許的 API 請求總數上限。按用戶/Key 維度計數，僅 API Key 呼叫計入。單一 Key 可另行覆蓋。超限回傳 HTTP 429（業務碼 42902）。',
  'pages.openapi.planTiers.maxApps': '應用數上限',
  'pages.openapi.planTiers.maxAppsTip': '該檔位開發者最多可建立的開放平台應用數量。',
  'pages.openapi.planTiers.maxKeys': '每應用 Key 上限',
  'pages.openapi.planTiers.maxKeysTip': '每個應用下最多可建立的 API Key 數量。',
  'pages.openapi.planTiers.allowedScopes': '允許權限（scopes）',
  'pages.openapi.planTiers.allowedScopesTip':
    '該檔位允許申請/授予的介面權限範圍。應用與 API Key 的實際權限為此處勾選集合的子集。',
  'pages.openapi.planTiers.save': '保存',
  'pages.openapi.planTiers.saved': '已保存',
  'pages.openapi.planTiers.saveFailed': '保存失敗',
  'pages.openapi.planTiers.loadFailed': '載入套餐失敗',
  'pages.openapi.planTiers.readonly': '觀察員唯讀，無法修改套餐檔位',

  'pages.openapi.usersUsage.title': '開放平台用戶限額與今日用量',
  'pages.openapi.usersUsage.userId': '用戶 ID',
  'pages.openapi.usersUsage.username': '用戶名',
  'pages.openapi.usersUsage.level': '等級',
  'pages.openapi.usersUsage.developerEnabled': '開通狀態',
  'pages.openapi.usersUsage.plan': '套餐',
  'pages.openapi.usersUsage.rateLimitQps': 'QPS 上限',
  'pages.openapi.usersUsage.dailyQuota': '日配額',
  'pages.openapi.usersUsage.todayUsed': '今日已用',
  'pages.openapi.usersUsage.loadFailed': '加載失敗',

  'pages.openapi.admin.usageLogsTitle': '開放平台呼叫審計',
  'pages.openapi.admin.usageLogsList': '全局呼叫記錄',
  'pages.openapi.admin.disableKeyConfirm': '確定停用該 API Key？',
  'pages.openapi.admin.disableKey': '停用 Key',
  'pages.openapi.admin.keyDisabled': '已停用',
  'pages.admin.user.openapiDeveloperEnabled': '開放平台',
  'pages.admin.user.openapi.on': '已開通',
  'pages.admin.user.openapi.off': '未開通',
  'pages.admin.user.openapiLevel': '開放平台等級',
  'pages.admin.user.openapiDeveloperEnabled.label': '開通開發者',
  'pages.admin.user.openapiLevel.label': '等級',
  'pages.admin.user.openapiLevel.placeholder': '1-5',
};
